var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.markerTypes),function(ref){
var key = ref[0];
var item = ref[1];
return _c('div',{key:'legend-' + item.type},[_c('img',{attrs:{"src":item.markerIcon}}),_c('span',[_vm._v(_vm._s(item.label))])])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }